// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"03c5e9ade93654e0fef6","482":"961076b08a2be09497d7","812":"02537bf7f0fd83b1c144","912":"c0389ba10526788bf44b"}[chunkId] + ".chunk.js";
};